global.MURI = {
    branch: 'muri',
    // dry-run marker:
    dry: true,
    o_possible: true,
    type: 'muri',


    canCalc: function(e) {
	BC.debug('MURI.canCalc(): Checking ...', '', 64);
	PRIV.calcable = MURI.haveRisk(e);
	return PRIV.calcable;
    },

    change: function(e) {
	BC.debug('MURI.change()', '...starting...', 64);
	if (! MURI.haveRisk(e)) {
	    ALL.chgProduct('muri', null);
	    ALL.notifyHeight();
	    return;
	}
	JQ('#div_muri_vers').show();
	MURI.recalc();
	ALL.notifyHeight();
    },

    chkWF: function(event) {
	// WF muss >= 75 und <= 250 sein
	var muri_wf = parseInt(JQ('#f_muri_wf').val());
	if (muri_wf > 250 || muri_wf < 75) {
	    ALL.showHint('Multi-Risk-Police: Die Wohnfläche muss mindestens 75 qm und darf maximal 250 qm betragen.');
	    return;
	}
    },

    haveRisk: function(e) {
	BC.debug('MURI.haveRisk(): Checking ...', e, 64);
	// valid = true : Alle Risikomerkmale vorhanden
	var valid = true;
	var _plz = parseInt(JQ('#f_muri_plz').val());
	var _str = JQ('#f_muri_str').val();
	var _hnr = JQ('#f_muri_hnr').val();
	var _wf = parseInt(JQ('#f_muri_wf').val());
	var _bjr = parseInt(JQ('#f_muri_bjr').val());
	if (JQ("#f_muri_efh_0").is(':checked')) {
	    ALL.showHint('Multi-Risk: Dieses Produkt ist ausschließlich für selbstbewohnte Einfamilienhäuser ohne gewerbliche Nutzung möglich.', 1);
	    valid = false;
	}
	if (valid && ! JQ("#div_muri_risk input[name='muri_efh']").is(':checked')) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk: Bitte angeben, ob gewerbliche Nutzung im Gebäude stattfindet.', 1);
		BC.debug('MURI.haveRisk(): Missing muri_efh', null, 64);
	    }
	    valid = false;
	}
	if (valid && ! _plz) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk-Police: Bitte die PLZ angeben.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_plz', null, 64);
	    valid = false;
	}
	if (valid && ! _str) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk-Police: Bitte die Strasse (ohne Hausnummer) eingeben.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_str', '', 64);
	    valid = false;
	}
	if (valid && ! _hnr) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk-Police: Bitte die Hausnummer eingeben.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_hnr', null, 64);
	    valid = false;
	}
	if (valid && ! _wf) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk-Police: Bitte die Wohnfläche eingeben.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_wf', null, 64);
	    valid = false;
	}
	if (valid && ! _bjr) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk: Bitte das Baujahr eingeben.', 1);
		BC.debug('MURI.haveRisk(): Missing muri_bjr', null, 64);
	    }
	    valid = false;
	}
	if (valid && ! JQ("#div_muri_risk input[name='muri_auw']").is(':checked')) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk-Police: Bitte die Bauart / Außenwände angeben.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_auw', null, 64);
	    valid = false;
	}
	if (valid && ! JQ("#div_muri_risk input[name='muri_ded']").is(':checked')) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk-Police: Bitte die Art der Bedachung angeben.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_ded', null, 64);
	    valid = false;
	}
	if (valid && ! JQ("#div_muri_risk input[name='muri_dmg']").is(':checked')) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk: Bitte angeben, ob es sich um ein denkmalgeschütztes Gebäude handelt.', 1);
		BC.debug('MURI.haveRisk(): Missing muri_dmg', null, 64);
	    }
	    valid = false;
	}
	if (valid && ! JQ("#div_muri_risk input[name='muri_sbg']").is(':checked')) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk: Bitte angeben, ob sich ein Schwimmbad im Gebäude befindet.', 1);
		BC.debug('MURI.haveRisk(): Missing muri_sbg', null, 64);
	    }
	    valid = false;
	}
	if (valid && ! JQ("#div_muri_risk input[name='muri_mins']").is(':checked')) {
	    if (! MURI.dry) {
		ALL.showHint('Multi-Risk: Bitte angeben, ob Mindestsicherungen vorhanden sind.', 1);
	    }
	    BC.debug('MURI.haveRisk(): Missing muri_mins', null, 64);
	    valid = false;
	}
	return valid;
    },

    init: function() {
    PRIV.hideLogoutAndAdministration();
	BC.debug('MURI.init():', '', 64);
    },

    recalc: function(e) {
	BC.debug('MURI.recalc():', '', 256);
	if (! MURI.canCalc()) {
	    BC.debug('MURI.recalc():', 'Cannot calc - check logs!', 16);
	    return;
	}
	var sa = PRIV.make_sa('muri');
	BC.debug('MURI.recalc():', sa, 64);
	JQ.getJSON(JSONURI, sa, MURI.setPremium);
	ALL.chkContactData();
    },

    reset: function() {
	BC.debug('MURI.reset()', '...starting...', 64);
	MURI.change();
    },

    setPremium: function(data) {
	BC.debug('MURI.setPremium():', data, 64);
 	ALL.chkError(data);
	if (data.ERROR) {
	    return;
	}
	JQ.each(data, function(key, val) {
	    if (key == 'DirA' && val && val.length) {
		PRIV.setDirAnfrage(val);
		return;
	    } else if (JQ('#f_muri_' + key).length) {
		JQ("#f_muri_" + key).text(val.str);
	    }
	    if (key == 'mpr2' && val.val) {
		JQ('#l_muri_net2').text('Jährliche Nettoprämie Multi-Risk-Police (Mindestprämie!):');
	    } else if (key == 'mpr2') {
		JQ('#l_muri_net2').text('Jährliche Nettoprämie Multi-Risk-Police:');
	    }
	    if (key == 'brt1' && val.str) {
		ALL.chgProduct('muri', val.str);
	    }
	});
	ALL.notifyHeight();
    }
};